export const FORM = {
  // for components rendered inside the form
  PADDING_BOTTOM: '10rem',
  BOX_SHADOW_FORM: '-0.5px 1px 3px -1px rgba(0,0,0,0.75);',
  BORDER: '1px solid #e7e7e7',
  BORDER_RADIUS_IMAGE: '5px',
  PADDING_BUTTON: '0.5rem',
  MARGIN: '10px',
  HEIGHT: '65rem',
};
export const BASE_PANEL = {
  BOX_SHADOW: '-0.5px 1px 3px -1px rgba(0,0,0,0.75);',
  MARGIN_TOP: '10px',
  MARGIN_LEFT: '15px',
  MARGIN_RIGHT: '15px',
};
export const stripeForm = {
  WIDTH: '38rem',
  HEIGHT: '19rem',
};

export const WIDGET = {
  NEWSFEED: {
    height: '600px',
  },
  Calendar: {
    height: '600px',
  },
};

export const CALENDAR_UI = {
  height: '85vh',
  maxWidth: '90vw',
  padding: '15px',
};

export const SUB_FORM_CONTAINER = {
  height: '65vh',
};

export const LIST_VIEW = {
  HEIGHT: '70vh',
};

export const SIGNATURE = {
  WIDTH: '300px',
  HEIGHT: '250px',
};

export const MASK = {
  OPACITY_LOW: 0.4,
};

export const ADMIN_PAGE = {
  HEIGHT: '90vh',
};
